import * as React from "react";
import { Checkbox, Col, Form, Input, Row, Select } from "antd";

import { FormInstance } from "antd/lib/form";
import { IDocumentType } from "../../../documentTypes/model/DocumentType";
import SelectInput from "../../../core/ui/components/SelectInput";
import {
  DocumentStatus,
  VisibilityLevels
} from "../../../core/common/Constants";
const { Option } = Select;
const FormFields = {
  ID: "id",
  DOCUMENT_TYPE_ID: "documentTypeId",
  VISIBILITY_LEVEL: "visibilityLevel",
  VALID: "valid",
  STATUS: "status"
};

interface Props {
  translate: any;
  form: FormInstance;
  documentTypes: IDocumentType[];
  organisationId: number;
  rowData?: IDocumentType;
  placeholder: string;
}

interface State {}

export default class OrganisationDocumentTypeForm extends React.Component<
  Props,
  State
> {
  render() {
    let { form, documentTypes, translate, rowData, placeholder } = this.props;

    rowData &&
    Object.keys(rowData).length > 0 &&
    rowData.visibilityLevels !== null &&
    rowData.visibilityLevels.length > 0
      ? form.setFieldsValue({ visibilityLevels: rowData.visibilityLevels })
      : form.setFieldsValue({
          visibilityLevels: [
            { status: DocumentStatus.IN_PROGRESS },
            { status: DocumentStatus.RECORDED },
            { status: DocumentStatus.VERIFIED },
            { status: DocumentStatus.PUBLISHED },
            { status: DocumentStatus.ARCHIVED },
            { status: DocumentStatus.INVALIDATED }
          ]
        });
    return (
      <Form
        layout={"vertical"}
        form={form}
        initialValues={{
          visibilityLevels:
            rowData &&
            Object.keys(rowData).length > 0 &&
            rowData.visibilityLevels !== null &&
            rowData.visibilityLevels.length > 0
              ? rowData.visibilityLevels
              : [
                  { status: DocumentStatus.IN_PROGRESS },
                  { status: DocumentStatus.RECORDED },
                  { status: DocumentStatus.VERIFIED },
                  { status: DocumentStatus.PUBLISHED },
                  { status: DocumentStatus.ARCHIVED },
                  { status: DocumentStatus.INVALIDATED }
                ]
        }}
      >
        <Form.Item
          name={FormFields.ID}
          initialValue={rowData?.id}
          style={{ display: "none" }}
        >
          <Input />
        </Form.Item>
        <Form.Item
          style={{ display: "none" }}
          label={translate("editors.organisations.valid")}
          name={FormFields.VALID}
          valuePropName={"checked"}
          initialValue={rowData?.valid ?? true}
        >
          <Checkbox />
        </Form.Item>
        <Col xs={24} sm={24}>
          <Form.Item name={FormFields.ID} initialValue={rowData?.id}>
            <SelectInput
              disabled={rowData?.id ? true : false}
              placeholder={placeholder}
              allowClear
              showSearch={true}
              notFoundContent={translate("search.no_data")}
              selectOptionKey={"id"}
              selectOptionValue={"name"}
              selectOptions={rowData && rowData.id ? [rowData] : documentTypes}
            />
          </Form.Item>
        </Col>
        <Form.List name="visibilityLevels">
          {(fields, { add, remove }) => {
            return (
              <>
                {fields.map((field, index) => (
                  <Row>
                    <Col span={5}>
                      <Form.Item name={[index, FormFields.STATUS]}>
                        <Select
                          disabled={true}
                          style={{ width: 120 }}
                          placeholder={translate("article.select_category")}
                          allowClear
                          showSearch={true}
                          notFoundContent={translate("search.no_data")}
                        >
                          <Option value={DocumentStatus.IN_PROGRESS}>
                            {translate(
                              `editors.status_values.${DocumentStatus.IN_PROGRESS}`
                            )}
                          </Option>
                          <Option value={DocumentStatus.RECORDED}>
                            {translate(
                              `editors.status_values.${DocumentStatus.RECORDED}`
                            )}
                          </Option>
                          <Option value={DocumentStatus.VERIFIED}>
                            {translate(
                              `editors.status_values.${DocumentStatus.VERIFIED}`
                            )}
                          </Option>
                          <Option value={DocumentStatus.PUBLISHED}>
                            {translate(
                              `editors.status_values.${DocumentStatus.PUBLISHED}`
                            )}
                          </Option>
                          <Option value={DocumentStatus.ARCHIVED}>
                            {translate(
                              `editors.status_values.${DocumentStatus.ARCHIVED}`
                            )}
                          </Option>
                          <Option value={DocumentStatus.INVALIDATED}>
                            {translate(
                              `editors.status_values.${DocumentStatus.INVALIDATED}`
                            )}
                          </Option>
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={15}>
                      <Form.Item
                        name={[index, FormFields.VISIBILITY_LEVEL]}
                        initialValue={
                          rowData?.visibilityLevels?.[0]?.visibilityLevel
                        }
                        rules={[
                          {
                            required: true,
                            message: translate(
                              "editors.attachment_types.required_messages"
                            )
                          }
                        ]}
                      >
                        <Select
                          style={{ width: 120 }}
                          placeholder={translate("article.select_category")}
                          allowClear
                          showSearch={true}
                          notFoundContent={translate("search.no_data")}
                        >
                          <Option value={1}>
                            {translate(
                              `editors.visibility_levels.${VisibilityLevels.PRIVATE}`
                            )}
                          </Option>
                          <Option value={2}>
                            {translate(
                              `editors.visibility_levels.${VisibilityLevels.INTERNAL}`
                            )}
                          </Option>
                          <Option value={3}>
                            {translate(
                              `editors.visibility_levels.${VisibilityLevels.GROUP}`
                            )}
                          </Option>
                          <Option value={4}>
                            {translate(
                              `editors.visibility_levels.${VisibilityLevels.PUBLIC}`
                            )}
                          </Option>
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>
                ))}
              </>
            );
          }}
        </Form.List>
      </Form>
    );
  }
}
